import React, { useContext, useEffect, useState } from 'react'
import { Box, Grid, GridItem, Heading, Text } from '@chakra-ui/react'
import { MainContext } from '../../context'
import { RiCloseFill, RiSearchLine } from 'react-icons/ri'
import { searchPromotionDataLayer } from '../../utils/gtmDatalayer'
import { SearchBar } from '../SearchBar/SearchBar'

const Header = ({ accentColor, dictionary, setName, fontFamily, skin }) => {
  const { setFilters, filters, isDesktop } = useContext(MainContext)

  const [isExpanded, setExpanded] = useState(false)

  const [term, setTerm] = useState()
  const [debouncedTerm, setDebouncedTerm] = useState()

  useEffect(() => {
    const timer = setTimeout(() => setTerm(debouncedTerm), 1500)
    return () => clearTimeout(timer)
  }, [debouncedTerm])

  useEffect(() => {
    if (term !== undefined) {
      if (term.length >= 3) {
        handleNameSearch(term)
      } else if (term.length === 0) {
        handleNameSearch()
      }
    }
  }, [term])

  const handleNameSearch = (term) => {
    setFilters({ ...filters, name: term })
    searchPromotionDataLayer(term, skin)
  }

  /* const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      const searchName = name
      handleNameSearch(searchName)
    }
  } */

  const handleClose = () => {
    if (term === undefined || term.length <= 2) {
      setTerm()
      setDebouncedTerm()
      setExpanded(false)
    } else {
      setTerm()
      setDebouncedTerm()
      setExpanded(false)
      handleNameSearch()
    }
  }

  const renderSearchBar = () => {
    return isExpanded === false ? null : (
      <SearchBar
        accentColor={skin === 'FINSUS' ? '#23223F' : accentColor}
        isDesktop={isDesktop}
        dictionary={dictionary}
        fontFamily={fontFamily}
        isExpanded={isExpanded}
        setDebouncedTerm={setDebouncedTerm}
      />
    )
  }

  const renderIcon = () => {
    return isExpanded === false ? (
      <Box id='searchName' onClick={() => setExpanded(true)}>
        <RiSearchLine
          fontSize='2rem'
          color={skin === 'FINSUS' ? '#23223F' :'#001B69'} 
          style={{ cursor: 'pointer' }}
        />
      </Box>
    ) : (
      <Box id='closeSearch' onClick={() => handleClose()}>
        <RiCloseFill
          style={{ marginLeft: '.6rem', cursor: 'pointer' }}
          color={skin === 'FINSUS' ? '#23223F' :'#001B69'} 
          fontSize='2.2rem'
        />
      </Box>
    )
  }

  const firstElement = () => {
    if (isDesktop === 'desktop') {
      // if skin is coppel adds a different copy to be next to search bar
      return (
        <Box
          w='100%'
          display='flex'
          alignItems='center'
          justifyContent='flex-start'
        >
          {skin === 'COPPEL' ? (
            <Text
              fontSize='22px'
              color={accentColor}
              fontFamily={skin === 'COPPEL' ? 'Circular Std Bold' : fontFamily}
              paddingLeft='4rem'
              fontWeight='700'
            >
              {skin === 'COPPEL'
                ? 'Compra en los siguientes comercios afiliados y gana más.'
                : 'Conoce las promociones y beneficios que tenemos para ti'}
            </Text>
          ) : (
            <Heading
              fontSize={['3xl', '5xl', '6xl', '5xl']}
              color={accentColor}
              fontFamily={fontFamily}
              fontWeight='700'
            >
              {dictionary.HEADER.title}
            </Heading>
          )}
        </Box>
      )
    } else {
      return (
        <Box
          w='100%'
          display='flex'
          alignItems='center'
          justifyContent='flex-end'
          cursor='pointer'
        >
          {renderSearchBar()}
          {renderIcon()}
        </Box>
      )
    }
  }

  const secondElement = () => {
    if (isDesktop === 'desktop') {
      return (
        <Box
          w='100%'
          display='flex'
          alignItems='center'
          justifyContent='flex-end'
        >
          {renderSearchBar()}
          {renderIcon()}
        </Box>
      )
    } else {
      return (
        <Box
          w='100%'
          display='flex'
          alignItems='center'
          justifyContent='center'
        >
          {skin === 'COPPEL' ? null : (
            <Heading
              mt='2rem'
              fontSize={['4xl', '5xl', '5xl', '5xl']}
              color={accentColor}
              fontFamily={fontFamily}
              fontWeight='700'
            >
              {dictionary.HEADER.title}
            </Heading>
          )}
        </Box>
      )
    }
  }

  return (
    <Box w='100%' h='auto'>
      <Grid w='100%' h='100%' templateColumns='repeat(12, 2fr)'>
        <GridItem
          colSpan={[12, 12, 12, 7]}
          h='100%'
          display='flex'
          alignItems='center'
          justifyContent='center'
        >
          {firstElement()}
        </GridItem>
        <GridItem
          colSpan={[12, 12, 12, 5]}
          h='100%'
          display='flex'
          alignItems='center'
          justifyContent='center'
        >
          {secondElement()}
        </GridItem>
      </Grid>
    </Box>
  )
}

export default Header
